//ordered by priority. If user has multiple roles, landing page will be the top-most
const LANDING_PAGES = (userId) => {
  return {
    ADMIN: 'dashboard',
    DEFAULT: `manage/users/${userId}`
  };
};

export default LANDING_PAGES;
